import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { FormControl, FormGroup } from "@angular/forms";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/content-search/models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            homePageId: new FormControl<string>(initialSearchParams.homePageId),
            searchText: new FormControl<string>(initialSearchParams.searchText)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup {
        return this.formInstance;
    }

    public get pageNumber(): FormControl<number> {
        return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>;
    }

    public get homePageId(): FormControl<string> {
        return this.formInstance.get(nameof<FormSearchParametersModel>("homePageId")) as FormControl<string>;
    }

    public get searchText(): FormControl<string> {
        return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>;
    }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
        });
    }
}
